// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"CardTemplate_cardHeader__3-kHY","cardId":"CardTemplate_cardId___Q-_Z","card":"CardTemplate_card__2cvN7"};